<template>
  <div class="w-full">
    <UsernamePassword
      v-if="authType === 'user'"
      @login-success="$emit('login-success')"
    />

    <ShopifyLogin
      v-if="authType === 'shopify'"
      @login-success="$emit('login-success')"
      @loading="onShopifyLoading"
    />
  </div>
</template>

<script>
import UsernamePassword from "./UsernamePassword";
import ShopifyLogin from "./ShopifyLogin";

export default {
  name: "Login",
  components: {
    UsernamePassword,
    ShopifyLogin
  },
  props: {
    authType: {
      default: "shopify",
      required: true,
      type: String
    }
  },
  methods: {
    onShopifyLoading(loading) {
      this.$emit("shopify-loading", loading);
    }
  }
};
</script>
